import angular from 'angular';
import { EnvironmentService } from '../../../../environment';

import {
  SELECTOR as UCloudinarySrcSelector,
  UCloudinarySrcDirective,
} from './cloudinary-image.directive';

export const UCloudinaryImageDirectives = angular
  .module('components.u-cloudinary-image', [EnvironmentService.name])
  .directive(UCloudinarySrcSelector, UCloudinarySrcDirective);
